import { render, staticRenderFns } from "./EditableTitle.vue?vue&type=template&id=7008ca24&scoped=true"
import script from "./EditableTitle.vue?vue&type=script&lang=js"
export * from "./EditableTitle.vue?vue&type=script&lang=js"
import style0 from "./EditableTitle.vue?vue&type=style&index=0&id=7008ca24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008ca24",
  null
  
)

export default component.exports